import React from 'react';

class Text extends React.Component {
  constructor(props) {
    super(props);
    let value = '';
    if (props.value) {
      value = props.value;
    }

    this.state = {
      value,
    };
  }

	handleChange = (e) => {
	  this.setState({ value: e.target.value });
	  const data = {};
	  data[this.props.name] = e.target.value;
	  this.props.setFormData(data);
	};

	// eslint-disable-next-line camelcase
	UNSAFE_componentWillReceiveProps(nextProps) {
	  if (nextProps.name !== this.props.name) {
	    this.setState({ value: '' });
	  }
	}

	render() {
	  let className;

	  if (this.props.small) {
	    className = 'form-control--sw dib';
	  } else {
	    className = 'form-control';
	  }
	  if (this.props.className) {
	    className = `${className} ${this.props.className}`;
	  }
	  var wrapClass = '';
	  if (this.props.wrapClass) {
	    wrapClass = this.props.wrapClass;
	  }
	  let type = 'text';
	  if (this.props.type) {
	    type = this.props.type;
	  }

	  var wrapClass = 'form-group ';
	  if (this.props.wrapClass) {
	    wrapClass += this.props.wrapClass;
	  }
	  if (this.props.errorMsg) {
	    wrapClass += ' error';
	  }

	  return (
  <div className={wrapClass}>
    <label>{this.props.title}</label>
    <input
      readOnly={this.props.readonly}
      type={type}
      value={this.state.value}
      placeholder={this.props.placeholder}
      className={className}
      name={this.props.name}
      onChange={this.handleChange}
    />
    {
					this.props.errorMsg
					?
  <div className="error">
    <div className="inner">
      {this.props.errorMsg}
    </div>
  </div>
					:
					null
				}
  </div>
	  );
	}
}

module.exports = Text;
